export function toOrderable<T>(items: T[]): Array<T & { order: number }> {
  return items.map((item, index) => ({ ...item, order: index }));
}
